import { FLOODGATE_API_ROOT, FloodgateSettingDataType } from './constants';
import { makeDeleteRequest } from 'owa-ows-gateway';
import prefetch from 'owa-service/lib/prefetch';

export default function deleteSettings(request: FloodgateSettingDataType) {
    prefetch(() => {
        makeDeleteRequest(
            FLOODGATE_API_ROOT,
            request,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            true /* isThrottled */
        );
    });
}
